module.exports = __webpack_public_path__ + "public/images/reviews/svetlana-mardanova.6f2a2ef36bfce32dbf1e8e32f42fb352.jpg";